export const ListaRadnogVremenaResourcesDE: ListaRadnogVremenaResourcesInterface =
  {
    title: "Arbeitszeitliste",
    errors: {
      query:
        "Beim Laden der Benutzer ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    },
    inputFields: {
      endDate: {
        label: "Enddatum",
      },
      startDate: {
        label: "Startdatum",
      },
      user: {
        error: "Bitte wählen Sie einen Benutzer aus",
        label: "Benutzer auswählen",
        name: "user",
        placeholder: "Benutzer auswählen",
      },
    },
    pdf: {
      button: "PDF herunterladen",
      document: {
        ukupnoVrijeme: "Gesamtstunden",
        name: "Vor- und Nachname",
        title: "Arbeitszeitnachweis",
        odabraniPeriod: "Ausgewählter Zeitraum",
        potpisFooter: "Unterschrift",
        upisaoFooter: "Eingegeben von",
        entryType: "Evidenztyp",
        napomena: "Notiz",
        pocetak: "Beginn",
        pocetakPauze: "Pausenbeginn",
        potpisano: "Unterschrift",
        zavrsetak: "Ende",
        zavrsetakPauze: "Pausenende",
        tipovi: {
          DEZURA: "Bereitschaftsdienst",
          ODSUSTVO: "Abwesenheit",
          PRIPRAVNOST: "Bereitschaft",
          RADNOVRIJEME: "Arbeitszeit",
          RADUSMJENAMA: "Schichtarbeit",
          TERENSKIRAD: "Außendienstarbeit",
          BOLOVANJE: "Krankenstand",
          SLOBODANDAN: "Freier Tag",
        },
      },
    },
  };

interface InputFieldInterface {
  label: string;
  name: string;
  placeholder: string;
  error: string;
}

export interface RadnoVrijemePDFInterface {
  name: string;
  title: string;
  ukupnoVrijeme: string;
  odabraniPeriod: string;
  potpisFooter: string;
  upisaoFooter: string;
  entryType: string;
  pocetak: string;
  zavrsetak: string;
  pocetakPauze: string;
  zavrsetakPauze: string;
  napomena: string;
  potpisano: string;
  tipovi: {
    RADNOVRIJEME: string;
    RADUSMJENAMA: string;
    TERENSKIRAD: string;
    DEZURA: string;
    PRIPRAVNOST: string;
    ODSUSTVO: string;
    BOLOVANJE: string;
    SLOBODANDAN: string;
  };
}

export interface ListaRadnogVremenaResourcesInterface {
  title: string;
  errors: {
    query: string;
  };
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
    user: InputFieldInterface;
  };
  pdf: {
    button: string;
    document: RadnoVrijemePDFInterface;
  };
}
